import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="error-graphic">
            <div className="error-number">4</div>
            <div className="error-icon">
              <svg viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M13,17h-2v-2h2V17z M13,13h-2V7h2V13z"/>
              </svg>
            </div>
            <div className="error-number">4</div>
          </div>
          
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-message">
            Oops! The page you requested doesn't exist or may have been moved.
          </p>
          
          <div className="action-buttons">
            <Link to="/" className="home-button">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path fill="currentColor" d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
              </svg>
              Return Home
            </Link>
            
            <button onClick={() => window.history.back()} className="back-button">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path fill="currentColor" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
              </svg>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;